import VoluntaryContractModule from './Voluntary'
import SupportContractModule from './Support'
import RecipientContractModule from './Recipient'

export default {
  subModules: {
    voluntary: VoluntaryContractModule,
    support: SupportContractModule,
    recipient: RecipientContractModule,
  },
}
